export default class FunctionQueue {
  static queue = [];
  static workingOnPromise = false;
  static currentPending = 0;
  static MAX_REQ = 20;

  static async enqueue(url,clbk,errclbk) {
    return new Promise((resolve, reject) => {
        this.queue.push({ u:url,c:clbk,e:errclbk});
        this.dequeue();
    });
  }

static sleep(ms){
  return new Promise(resolve => setTimeout(resolve, ms));
}

static async dequeue() {
  
      if (!this.workingOnPromise && this.currentPending < this.MAX_REQ) {
        const item = this.queue.shift();
        if (item){
          
          this.workingOnPromise = true;

            console.log("[" + this.currentPending + "] dequeue:"+item.u)

            await this.sleep(60);
            let apiUrl = item.u;
            this.currentPending += 1;
            fetch(apiUrl)
              .then( res => res.json())
              .then( data => {item.c(data);this.currentPending -= 1;}).catch(()=>{this.currentPending -= 1;item.e()});

            this.workingOnPromise = false;
            this.dequeue();
          
        }else{
          return false; // no item
        } 
      }else{
        await this.sleep(20);
        this.dequeue();
      }
        
      
      
      return true;  
  

    
  }
}
/*


static async dequeue() {
      if (this.workingOnPromise) {
        return false;
      }
      const item = this.queue.shift();
      if (!item) {
        return false;
      }
      try {
        this.workingOnPromise = true;
          item.promise.then((value) => {
            console.log("then")
            this.workingOnPromise = false;
            item.resolve(value);
            this.dequeue();
          })
          .catch(err => {
            console.log("err")
            this.workingOnPromise = false;
            item.reject(err);
            this.dequeue();
          })
      } catch (err) {
        this.workingOnPromise = false;
        item.reject(err);
        this.dequeue();
      }
      return true;  
  

    
  }

*/